import { useState, type ReactNode } from "react";

import { ErrorNote, errorText } from "@/components/ErrorNote";

/** Standard mutation error feedback (U11): ApiError unwrap + a ready-to-place
 *  error node. Was the hand-rolled `setErr` + red-span pattern ×4. */
export function useMutationFeedback(): {
  err: string;
  /** wire to useMutation onError */
  fail: (e: unknown) => void;
  /** wire to useMutation onSuccess (clears the error) */
  ok: () => void;
  /** render this where the error should appear (null when none) */
  errorNode: ReactNode;
} {
  const [err, setErr] = useState("");
  return {
    err,
    // One unwrap, in ErrorNote — this hook and the eleven call sites that
    // used to hand-roll a panel now format a failure identically.
    fail: (e: unknown) => setErr(errorText(e)),
    ok: () => setErr(""),
    errorNode: err ? <ErrorNote error={new Error(err)} /> : null,
  };
}
